export const month_names_short = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const rewardCategory = [
  {
    id: 1,
    key: "reward",
    name: "Rewards",
  },
  {
    id: 2,
    key: "discount",
    name: "Discount",
  },
  {
    id: 3,
    key: "myvoucher",
    name: "My Voucher",
  },
];

export const myVoucherCategory = [
  {
    id: 1,
    key: "allvoucher",
    name: "All Voucher",
  },
  {
    id: 2,
    key: "available",
    name: "Available",
  },
  {
    id: 3,
    key: "used",
    name: "Used/Expired",
  },
];

export const myVoucherInfo = [
  {
    id: 1,
    key: "howtouse",
    name: "How to use",
  },
  {
    id: 2,
    key: "overview",
    name: "Overview",
  },
  {
    id: 3,
    key: "moreinfo",
    name: "More Info",
  },
];
export const PointStart = [
  {
    id: 1,
    key: "point",
    name: "Points",
  },
  {
    id: 2,
    key: "star",
    name: "Stars",
  },
];
export const eventCategory = [
  {
    id: 1,
    name: "Today",
  },
  {
    id: 2,
    name: "Upcoming",
  },
];

export const listRsvpState = [
  {
    state: "not_attending",
    label: "Submit RSVP",
    color: "#3ED091",
  },
  {
    state: "attending",
    label: "Check In",
    color: "#EB5126",
  },
  {
    state: "attended",
    label: "Checked In",
    color: "#EAEAEA",
  },
];

export const btnRange = ["Week", "Month"];

export const allDays = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];

export const fullDayName = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const statusSnapReceipt = [
  {
    key: "on_progress",
    name: "On Progress",
    color: "#787979",
    bg: "#efefef",
  },
  {
    key: "approved",
    name: "Approved",
    color: "#3ED091",
    bg: "#ecfaf4",
  },
  {
    key: "rejected",
    name: "Rejected",
    color: "#ff5828",
    bg: "#ffeeea",
  },
];
